import { Component, OnInit, Input } from '@angular/core';
import { SummaryRating } from 'app/shared/models/summaryRating.model';

@Component({
    selector: 'app-chart-rating-pc',
    templateUrl: './chart-rating-pc.component.html',
    styleUrls: ['./chart-rating-pc.component.css']
})
export class ChartRatingPCComponent implements OnInit {
    @Input() ratings: string;
    summaryRatingList: SummaryRating[];

    positiveRating: number;
    okRating: number;
    negativeRating: number;

    //view: any[] = [600, 400];
    view: any;


    trafficLightPalette = {
        domain: ['#28a745', '#ffc107','#dc3545']
    }
    //pie
    showLabels = true;

 

    constructor() { }

    ngOnInit() {
        this.summaryRatingList = JSON.parse(JSON.stringify(this.ratings));
        this.positiveRating = this.summaryRatingList.find(x => x.name === 'Positive').value;
        this.okRating = this.summaryRatingList.find(x => x.name === 'OK').value;
        this.negativeRating = this.summaryRatingList.find(x => x.name === 'High Risk').value;
    }

}
